import { useTranslation } from "react-i18next";
import { Users as UsersFeature } from "@/partner/features/users";
import { Meta } from "@/shared/components";

export function UsersPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("users.pageTitle")} pageType="Partner" />
      <UsersFeature />
    </>
  );
}
